const column = [
  {
    label: "IndicatorName",
    field: "IndicatorName"
  },
  {
    label: "IndicatorCode",
    field: "IndicatorCode"
  },
  {
    label: "DataValue",
    field: "DataValue"
  },
  {
    label: "UpdateTime",
    field: "UpdateTime"
  }
  // {
  //   label: "UpdateTime",
  //   field: "UpdateTime"
  // },
  // {
  //   label: "BeginDate",
  //   field: "BeginDate"
  // },
  // {
  //   label: "EndDate",
  //   field: "EndDate"
  // }
  /* ,
  {
    label: "Country/Region",
    field: "location"
  },
  {
    label: "Statistical cycle",
    field: "time"
  },
  {
    label: "Unit",
    field: "unit"
  },
  {
    label: "Source",
    field: "resource"
  } */
]

export default column;